export const defaultStoreDesign = {
  templateKey: "classic",
  colorPalette: {
    primary: "#4BD053",
    secondary: "#248A3D",
    accent: "#FFB703",
    background: "#F7F9FB",
    surface: "#FFFFFF",
    text: "#202124"
  },
  productGrid: {
    mobileColumns: 1,
    tabletColumns: 2,
    desktopColumns: 3
  },
  productCard: {
    variant: "classic",
    imageFit: "contain",
    radius: 18,
    decoration: {
      enabled: false,
      image: "",
      animation: "shake",
      position: {
        x: 12,
        y: 0
      }
    }
  }
}

export const mergeStoreDesign = design => ({
  ...defaultStoreDesign,
  ...(design || {}),
  colorPalette: {
    ...defaultStoreDesign.colorPalette,
    ...((design && design.colorPalette) || {})
  },
  productGrid: {
    ...defaultStoreDesign.productGrid,
    ...((design && design.productGrid) || {})
  },
  productCard: {
    ...defaultStoreDesign.productCard,
    ...((design && design.productCard) || {}),
    decoration: {
      ...defaultStoreDesign.productCard.decoration,
      ...((design && design.productCard && design.productCard.decoration) || {}),
      position: {
        ...defaultStoreDesign.productCard.decoration.position,
        ...(
          (
            design &&
            design.productCard &&
            design.productCard.decoration &&
            design.productCard.decoration.position
          ) ||
          {}
        )
      }
    }
  }
})

export const getStoreDesignStyle = design => {
  const mergedDesign = mergeStoreDesign(design)
  const palette = mergedDesign.colorPalette

  return {
    "--store-primary": palette.primary,
    "--store-secondary": palette.secondary,
    "--store-accent": palette.accent,
    "--store-background": palette.background,
    "--store-surface": palette.surface,
    "--store-text": palette.text,
    "--color-primary": palette.primary,
    "--color-secondary": palette.secondary,
    "--color-ghost-white": palette.background
  }
}
